<ng-container [formGroup]="model">
    <div class="row">
        <div class="col-lg-6 col-md-12">
            <textarea
                [id]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                rows="{{ field.input.textAreaConfiguration?.rows }}"
                cols="{{ field.input.textAreaConfiguration?.cols }}"
                [readonly]="!isEditable"
                class="w-100"
                placeholder="..."
                pTextarea
                [attr.aria-invalid]="isInvalid">
            </textarea>

            @if (field.input.textAreaConfiguration?.hasVoiceTranscription === true && isEditable && browser.isChromiumBased()) {
                <app-reactive-dictado
                    transcriptionLabel="Grabar {{ field.label }}"
                    [speechTranscription]="model.get(field.name)?.value ?? ''"
                    (sendTranscription)="getAudio(field.name, $event)">
                </app-reactive-dictado>
            }
        </div>

        @if (field.input.textAreaConfiguration?.canTakePhoto === true) {
            <div class="col-lg-4 col-md-4 col-sm-12">
                <app-reactive-upload-images
                    [formModel]="model.getRawValue()"
                    [imageFolder]="form.name"
                    [formType]="form.type"
                    [imageDisplay]="'link'"
                    [imageName]="field.input.textAreaConfiguration?.photoField ?? null"
                    (sendImageName)="updateImageModel($event, field.input.textAreaConfiguration?.photoField ?? '')">
                </app-reactive-upload-images>
            </div>
        }
    </div>
</ng-container>
